module.exports = __webpack_public_path__ + "img/titleword.a9e881bc.png";